// ======================================================================
// File Name       : GroupDetailConfirmContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from 'react-bootstrap';
import ModalWrapper from '../../components/modal/ModalWrapper';
import GroupDetail from '../../components/group/GroupDetail';
import UserAttributeDetailConfirmContainer from '../userAttribute/UserAttributeDetailConfirmContainer';
import GroupAdminRelation from '../../components/group/GroupAdminRelation';
import GroupNotAdminRelation from '../../components/group/GroupNotAdminRelation';
import { canAccess } from '../../utils/AuthedUtils';
import * as groupActions from '../../actions/GroupAction';
import * as modalActions from '../../actions/ModalAction';
import * as Functions from '../../constants/FunctionConstants';
import * as ModalIds from '../../constants/ModalIds';
import { REDIRECT_MODAL } from '../../constants/GroupConstants';
import { SHOW_MESSAGE } from '../../constants/actionTypes/message';
import { RETURN_MAX_NUM_1000 } from '../../constants';
import { isSuperUser } from '../../utils/index';
import { getUserGroupRelation } from '../../actions/UserAction';

let okBtnClick = false;
class GroupDetailConfirmContainer extends Component {
  constructor() {
    super();
    this.handleEditBtn = this.handleEditBtn.bind(this);
    this.handleOKBtn = this.handleOKBtn.bind(this);
    this.handleBackBtn = this.handleBackBtn.bind(this);
  }

  handleBackBtn() {
    const { dispatch, modalId } = this.props;
    dispatch(modalActions.openModal(REDIRECT_MODAL[modalId].CANCEL));
  }

  handleEditBtn() {
    const { dispatch, modalId } = this.props;
    dispatch(modalActions.openModal(REDIRECT_MODAL[modalId].OK));
  }

  handleOKBtn() {
    const { dispatch, modalId } = this.props;
    if (!okBtnClick) {
      okBtnClick = true;
      dispatch(groupActions.saveGroup()).then(() => {
        okBtnClick = false;
      }).catch((error) => {
        const messageInfo = {
          statusCd: error.statusCd,
          message: error.message,
          targetModal: true,
          messageType: 'danger',
        };
        dispatch(modalActions.openModal(REDIRECT_MODAL[modalId].ERROR));
        dispatch({ type: SHOW_MESSAGE, ...messageInfo });
        okBtnClick = false;
      });
    }
  }

  getModalOptions() {
    const { modalId } = this.props;
    const footerBtns = [{ name: 'キャンセル', variant: 'default' }];
    if (canAccess(Functions.GROUP_EDIT)) {
      footerBtns.push({ name: '編集', onClick: this.handleEditBtn, variant: 'primary' });
    }
    const OPTIONS = {
      [ModalIds.GROUP_DETAIL]: {
        title: 'ユーザーグループ情報の詳細',
        footerBtns,
      },
      [ModalIds.GROUP_CONFIRM]: {
        title: '以下の内容で登録します',
        footerBtns: [
          { name: '戻る', onClick: this.handleBackBtn, variant: 'default' },
          { name: 'OK', onClick: this.handleOKBtn, variant: 'primary' },
        ],
      },
    };
    return OPTIONS[modalId];
  }

  render() {
    const { group, authority, modalId } = this.props;
    const { bySecernId } = group.structures;
    const { editingGroup, editingUserGroupAdmin, editingUserGroupNotAdmin, recordNumUserInGroup } = group;
    const isShowMessageMaxRecord = recordNumUserInGroup > RETURN_MAX_NUM_1000;
    return (
      <ModalWrapper {...this.getModalOptions()} dialogClassName="group-detail-dialog" hideModal={this.props.hideModal}>
        <Form className="form-horizontal">
          <div className="margin-left-right-minus-15">
            <GroupDetail editingGroup={editingGroup} groupBySecernId={bySecernId} />
            <UserAttributeDetailConfirmContainer />
          </div>
          <GroupAdminRelation
            editingUserGroupAdmin={editingUserGroupAdmin}
            authority={authority}
            isShowMessageMaxRecord={isShowMessageMaxRecord}
            isDetail={modalId === ModalIds.GROUP_DETAIL}
          />
          <GroupNotAdminRelation editingUserGroupNotAdmin={editingUserGroupNotAdmin} isShowMessageMaxRecord={isShowMessageMaxRecord} />
        </Form>
      </ModalWrapper>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { group, authority } = state;
  return { group, authority: authority.authorityInfo.bySecernId };
};
export default connect(mapStateToProps)(GroupDetailConfirmContainer);
